<style lang="scss" scoped>
.compare-container {
  width: 702px;
  margin: 0 auto;
    .split-line {
    width: 702px;
    height: 2px;
    margin: 0 auto;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(#1d1d1d, 0.06);
  }
  .sale-msg {
    height: 136px;
    display: flex;
    justify-content: center;
    align-items: center;
    .split-v {
      height: 88px;
      width: 2px;
      box-sizing: border-box;
      border-right: 1px solid #e9e9e9;
      margin: 0 76px;
    }
    .item {
      text-align: center;
      .price {
        font-size: 34px;
        color: #1d1d1d;
        line-height: 48px;
        font-weight: bold;
      }
      .percent {
        font-size: 34px;
        color: #ff2a4e;
        line-height: 48px;
        font-weight: bold;
        .arrow-up {
          width: 29px;
          height: 18px;
          margin-top: -5px;
        }
        &.up {
          color: #ff2a4e;
        }
        &.down {
          color: #00cc47;
        }
      }
      .desp {
        color: #999;
        font-size: 20px;
        line-height: 28px;
        margin-top: 4px;
        position: relative;
        .question-icon {
          height: 22px;
          width: 22px;
          margin-left: 6px;
        }
        .tips {
          position: absolute;
          width: 302px;
          height: 112px;
          background-image: url("https://oss.turingsenseai.com/1607667812937275932.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          padding: 18px 22px 0 24px;
          font-size: 24px;
          line-height: 34px;
          color: #ffffff;
          text-align: left;
          transform: translateY(-140px) translateX(-110px);
          z-index: 9999;
        }
      }

    }
  }
  .tab-container {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    .title {
      width: 90px;
      height: 116px;
      font-size: 28px;
      color: #1d1d1d;
      font-weight: bold;
      display: flex;
      // justify-content: center;
      // align-items: center;
      padding-top: 40px;
      box-shadow: 30px 0 15px -25px rgba(#000, 0.07);
    }
    .tab-list {
      flex: 1;
      height: 100px;
      overflow: hidden;
      position: relative;
      .tab-content {
        // position: absolute;
        width: 100%;
        height: 116px;
        display: flex;
        overflow-x: scroll;
        // align-items: center;
        padding-top: 32px;
        .tab-item {
          width: 120px;
          padding: 0 30px;
          font-size: 28px;
          color: #bbb;
          white-space: nowrap;
          &.selected {
            color: #1d1d1d;
          }
        }
      }
    }
  }
  .price-container {
    display: flex;
    justify-content: center;
    align-items: center;
    .lowest-container {
      background: url("./../../../assets/images/ai-picture/price-lowest-bg.png")
        0 0;
      background-repeat: no-repeat;
      background-size: cover;
      width: 360px;
      height: 133px;
      position: relative;
      top: -20px;
      transform: rotate(3deg);
      .price {
        // width: 131px;
        height: 52px;
        padding: 2px;
        // display: inline-block;
        background-color: #fff;
        border-radius: 4px;
        position: absolute;
        width: auto;
        display: flex;
        align-items: center;
        font-weight: bold;
        // margin: 55px 0 ;
        right: 30px;
        bottom: 25px;
        .pre {
          height: 100%;
          display: inline-block;
          background: #06d2c2;
          border-radius: 4px 0 0 4px;
          font-size: 24px;
          line-height: 52px;
        }
        .num {
          font-weight: bold;
          height: 100%;
          padding: 0 8px;
          display: inline-block;
          background-color: #1e2146;
          border-radius: 0 4px 4px 0;
          color: #fff;
          font-size: 34px;
          line-height: 52px;
        }
      }
    }
    .detail-item {
      width: 170px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .percent,
      .num {
        line-height: 48px;
        font-size: 34px;
        color: #00cc47;
        .arrow-icon {
          width: 29px;
          height: 18px;
        }
        &.up {
          color: #ff2a4e;
        }
        &.down {
          color: #00cc47;
        }
      }
      .num {
        color: #1d1d1d;
      }
      .desp {
        color: #999;
        font-size: 22px;
        line-height: 32px;
      }
    }
  }
  .charts-container {
    .price-charts {
      height: 520px;
    }
    .legend-container {
      position: relative;
      height: 80px;
      overflow: hidden;
      .legend-content {
        // position: absolute;
        width: 100%;
        height: 100px;
        display: flex;
        margin-top: 10px;
        overflow-x: scroll;
        .legend-item {
          display: flex;
          margin-right: 36px;
          .icon-container {
            height: 40px;
            width: 40px;
            border-radius: 50%;
            overflow: hidden;
          }
          .color-line {
            width: 26px;
            height: 4px;
            // margin-left: 12px;
            margin: 20px 12px;
            box-sizing: border-box;
          }
        }

      }
    }
    .desp {
      text-align: center;
      font-size: 18px;
      color: #999;
      line-height: 26px;
    }
  }
  .plat-price-container {
    margin-top: 60px;
    .title {
      font-size: 28px;
      line-height: 40px;
      color: #1d1d1d;
      margin-bottom: 22px;
      font-weight: bold;
    }
    .table-container {
      display: flex;
      position: relative;
      .table-bg {
        position: absolute;
        width: 100%;
        .header {
          height: 78px;
          background-color: #eeeeee;
        }
        .odd {
          height: 100px;
          background-color: #ffffff;
        }
        .even {
          height: 100px;
          background-color: #f7f7f7;
        }
      }
      .left {
        width: 150px;
        z-index: 1;
        .plat-name {
          padding-left: 24px;
          color: #1d1d1d;
          font-size: 22px;
          background-color: #eeeeee;
          height: 78px;
          display: flex;
          // justify-content: center;
          align-items: center;
        }
        .sale-lowest, .sale-num {
          height: 100px;
          padding-left: 24px;
          color: #999;
          background-color: #f7f7f7;
          font-size: 22px;
          display: flex;
          align-items: center;
        }
        .sale-lowest {
          background-color: #fff;
        }
      }
      .right {
        flex: 1;
        z-index: 1;
        position: relative;
        overflow: hidden;
        height: 278px;
        .right-content {
          // position: absolute;
          height: 300px;
          display: flex;
          width: 100%;
          overflow-x: scroll; 
          .plat-item {
            min-width: 165px;
            .header {
              color: #1d1d1d;
              font-size: 22px;
              background-color: #eeeeee;
              height: 78px;
              display: flex;
              justify-content: center;
              align-items: center;
              .logo {
                height: 52px;
                width: 52px;
                border-radius: 50%;
                overflow: hidden;
                img {
                  height: 100%;
                  width: 100%;
                }
              }
            }
            .sale-lowest, .sale-num {
              height: 100px;
              // padding-left: 24px;
              color: #1d1d1d;
              // background-color: #f7f7f7;
              font-size: 22px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .sale-lowest {
              // background-color: #fff;
              &.lowest {
                color: #6F9DD8 
              }
            }
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="compare-container">
    <div class="sale-msg">
      <div class="item">
        <div class="price">￥{{compareInfo.releasePrice / 100}}</div>
        <div class="desp">官方价</div>
      </div>
      <div class="split-v"></div>
      <div class="item">
        <div :class="`percent ${compareInfo.overflowPrice>100 ? 'up': 'down'}`">
          {{compareInfo.overflowPrice || 0}}% 
          <img v-if="compareInfo.overflowPrice>100" class="arrow-up" src="./../../../assets/images/ai-picture/up-arrow.png">
          <img v-if="compareInfo.overflowPrice<100" class="arrow-up" src="./../../../assets/images/ai-picture/down-arrow.png">
        </div>
        <div class="desp" @click="changeTip()">商品溢价
          <img class="question-icon" src="./../../../assets/images/ai-picture/question.png">
          <div class="tips" v-if="showTip">
            商品溢价=全新商品实时售价/官方价
          </div>
        </div>
      </div>
    </div>
    <div class="split-line"></div>

    <div class="tab-container">
      <div class="title">成色</div>
      <div class="tab-list">
        <div class="tab-content">
          <div
            :class="'tab-item ' + (index==selectedIndex ? 'selected': '')"
            v-for="(grade, index) in gradeList"
            :key="index"
            @click="changeTab(index)"
          >{{grade}}</div>
        </div>
      </div>
    </div>

    <div class="price-container">
      <div class="lowest-container">
        <!-- ￥7700 -->
        <div class="price">
          <div class="pre">￥</div>
          <div class="num">{{compareList[selectedIndex].netPrice/100 || 0}}</div>
        </div>
      </div>
      <div class="detail-item">
        <div :class="`percent ${compareList[selectedIndex].sevenDayCompare > 0 ? 'up': 'down'}`">
          {{compareList[selectedIndex].sevenDayCompare || 0}}%
          <img v-if="compareList[selectedIndex].sevenDayCompare > 0" class="arrow-icon" src="./../../../assets/images/ai-picture/up-arrow.png" />
          <img v-if="compareList[selectedIndex].sevenDayCompare < 0" class="arrow-icon" src="./../../../assets/images/ai-picture/down-arrow.png" />

        </div>
        <div class="desp">七天同比</div>
      </div>
      <div class="detail-item">
        <div class="num">{{compareList[selectedIndex].newsNetWorkNum || 0}}</div>
        <div class="desp">全网销量</div>
      </div>
    </div>

    <div class="charts-container">
      <div id="price-charts" class="price-charts"></div>
      <div class="legend-container">
        <div class="legend-content">
          <div class="legend-item" v-for="(legend, index) in compareList[selectedIndex].dataList" :key="index">
            <div class="icon-container">
              <img class="legend-icon" :src="legend.icon" />
            </div>
            <div class="color-line" :style="'border-color:' + legend.color + ';background-color: ' + legend.color"></div>
          </div>
        </div>
      </div>
      <div class="desp">
        图表价格走势仅作参考，具体价格以实际为准
      </div>
    </div>
    <div class="plat-price-container" v-if="compareList[selectedIndex].networkPrice && compareList[selectedIndex].networkPrice.length > 0">
      <div class="title">全网比价</div>
      <div class="table-container">
        <div class="table-bg">
          <div class="header"></div>
          <div class="odd"></div>
          <div class="even"></div>
        </div>
        <div class="left">
          <div class="plat-name">平台</div>
          <div class="sale-lowest">在售最低</div>
          <div class="sale-num">销量/件</div>
        </div>
        <div class="right">
          <div class="right-content">
            <div class="plat-item" v-for="(netWorkPrice, index) in compareList[selectedIndex].networkPrice" :key="index">
              <div class="header">
                <div class="logo">
                  <img :src="netWorkPrice.icon">
                </div>
                <!-- {{netWorkPrice.name}} -->
              </div>
              <div :class="`sale-lowest ${netWorkPrice.lowest ? 'lowest' : ''}`">￥{{netWorkPrice.salePrice/100 || '-'}}</div>
              <div class="sale-num">{{netWorkPrice.productNum || '-'}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import testImage from './../../../assets/images/ai-picture/up-arrow.png';

const platList = [
  // https://oss.turingsenseai.com/1603260680879999300.png
  {
    name: '包小鉴',
    icon: 'https://oss.turingsenseai.com/1603260680879999300.png',
    color: '#f363a5'
  },
  {
    name: '妃鱼',
    icon: 'https://oss.turingsenseai.com/1603260668052385675.png',
    color: '#33c6f7'
  },
  {
    name: '红布林',
    icon: 'https://oss.turingsenseai.com/1603260654923114122.png',
    color: '#01b088'

  },
  {
    name: '陈真',
    icon: 'https://oss.turingsenseai.com/1603260638470663331.png',
    color: '#f66b61'

  },
  {
    name: '寺库',
    icon: 'https://oss.turingsenseai.com/1603260621396412554.png',
    color: '#ffb55d'

  },
  {
    name: '心上',
    icon: 'https://oss.turingsenseai.com/1603260609225615758.png',
    color: '#296762'

  },
  {
    name: '只二',
    icon: 'https://oss.turingsenseai.com/1603260594855579054.png',
    color: '#00a2ff'

  },
  {
    name: '胖虎',
    icon: 'https://oss.turingsenseai.com/1603260577063272119.png',
    color: '#f1d310'

  },
  {
    name: '衣二三',
    icon: 'https://oss.turingsenseai.com/1603260558283648417.png',
    color: '#13d2c2'

  },
  {
    name: '名见',
    icon: 'https://oss.turingsenseai.com/1603260547270504264.png',
    color: '#d68fff'

  },
  {
    name: '百格',
    icon: 'https://oss.turingsenseai.com/1603260515001386141.png',
    color: '#8f2dd1'
  },
]

export default {
  props: {
    compareList: {
      default: () => {
        return []
      },
    },
    compareInfo: {
      default: () => {
        return {}
      } 
    }
  },
  data () {
    return {
      gradeList: [],
      selectedIndex: 0,
      tabScroll: null, // 成色tab滑动
      legendScroll: null, // 标志滑动
      platScroll: null, // 平台比价的滚动
      chartsOption: {},
      priceCharts: null,
      platData: {},
      showTip: false,
    }
  },
  // watch: {
  //   props: {
  //     deep: true,
  //     handler () {
  //       console.log('$$$$$$$$4', this.compareList);
  //       if (this.compareList && this.compareList.length > 0) {
  //         this.gradeList = this.compareList.map(item => {
  //           return item.newsName
  //         })

  //         this.priceCharts = echarts.init(document.getElementById('price-charts'));
  //         this.refreshData(this.selectedIndex);
  //       }
  //     }
  //   }
  // },
  methods: {
    changeTip () {
      this.showTip = !this.showTip;
    },
    changeTab (index) {
      this.selectedIndex = index;
      this.refreshData(index);
    },
    refreshData (index) {
      // console.log(this.compareList);
      const curData = this.compareList[index];
      curData['dataList'].forEach((item, index) => {
        // console.log(item, platList[item.source]);
        const source = item.source || 0;
        item.color = platList[source].color;
        item.name = platList[source].name;
        item.icon = platList[source].icon;
        // item.name = item.source;
      });
      // for (let i = 0; i < 10; i++) {
      //   curData['dataList'].push(curData['dataList'][0])
      // }
      if (curData['networkPrice']) {
        curData['networkPrice'].forEach((item, index) => {
          const source = item.source || 0;
          item.color = platList[source].color;
          item.name = platList[source].name;
          item.icon = platList[source].icon;
        })
        const priceList = [...curData['networkPrice']];
        priceList.sort((a, b) => { return a.salePrice - b.salePrice });
        if (priceList[0]) {
          priceList[0].lowest = true;
        }
      }
      // this.platData.dataList.forEach(item => {
      //   item.name = platList[item.type - 1].name;
      //   item.color = platList[item.type - 1].color;
      // });
      const series = curData.dataList.map(item => {
      // const series = this.platData.dataList.map(item => {
        return {
          name: item.name,
          type: 'line',
          data: item.data,
          symbolSize: 1,
          symbol: 'circle',
          smooth: true,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {
            width: 2,
            color: item.color,
          },
          itemStyle: {
            normal: {
              color: item.color,
              borderColor: item.color
            }
          }
        }
      })
      // this.platData = {
      //   ...this.platData
      // }

      const option = {
            backgroundColor: '#fff',
            // title: {
            //   text: '奢侈品销售情况',
            //   textStyle: {
            //     fontSize: 12,
            //     fontWeight: 400
            //   },
            //   left: 'center',
            //   top: '5%'
            // },
            // legend: {
            //   icon: 'circle',
            //   top: '15%',
            //   right: '5%',
            //   itemWidth: 6,
            //   itemGap: 20,
            //   textStyle: {
            //     color: '#556677'
            //   }
            // },
            tooltip: {
              trigger: 'axis',
              // position: 'inside',
              // position: ['15%', '5%'],
              axisPointer: {
                label: {
                  // show: true,
                  backgroundColor: '#fff',
                  color: '#556677',
                  borderColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(0,0,0,0)',
                  shadowOffsetY: 0
                },
                lineStyle: {
                  width: 2,
                  color: '#71a0cd'
                }
              },
              backgroundColor: '#fff',
              textStyle: {
                color: '#5c6c7c'
              },
              padding: [10, 10],
              extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)',
              // confine: true,
              // extraCssText: 'height:100px; width: 100px; background-color: pink; overflow-y: scroll'
            },
            grid: {
              top: '5%',
              bottom: '15%'
            },
            xAxis: [
              {
                type: 'category',
                data: curData['dateList'],
                axisLine: {
                  lineStyle: {
                    color: '#DCE2E8'
                  }
                },
                axisTick: {
                  show: true,
                  interval: 4
                },
                axisLabel: {
                  interval: 4,
                  textStyle: {
                    color: '#999999'
                  },
                  // 默认x轴字体大小
                  fontSize: 12,
                  // margin:文字到x轴的距离
                  margin: 15
                },
                axisPointer: {
                  label: {
                    // padding: [11, 5, 7],
                    padding: [0, 0, 10, 0],
                    margin: 15,
                    // 移入时的字体大小
                    // fontSize: 20,
                    backgroundColor: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [{
                        offset: 0,
                        color: '#fff' // 0% 处的颜色
                      }, {
                          // offset: 0.9,
                        offset: 0.86,
                        color: '#fff' // 0% 处的颜色
                      }, {
                        offset: 0.86,
                        color: '#33c0cd' // 0% 处的颜色
                      }, {
                        offset: 1,
                        color: '#33c0cd' // 100% 处的颜色
                      }],
                      global: false // 缺省为 false
                    }
                  }
                },
                boundaryGap: false
              }],
            yAxis: [
              {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#DCE2E8'
                    }
                },
                axisLabel: {
                    textStyle: {
                        color: '#999999'
                    },
                    fontSize: 8,
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                      color: '#f7f7f7'
                    }
                },
                max: function (value) {
                  return value.max * 1.2
                },
                min: function (value) {
                  return value.min * 0.8
                }
              }],
            series: series,
          };
      this.priceCharts.clear();
      this.priceCharts.setOption(option);
    }
  },
  mounted () {
    if (this.compareList && this.compareList.length > 0) {
      this.gradeList = this.compareList.map(item => {
        return item.newsName
      })
      this.priceCharts = echarts.init(document.getElementById('price-charts'));
      this.refreshData(this.selectedIndex);
    }
  }
}
</script>
